(function() {
  const initMainCollectionNav = () => {
    const tabsParent = $(".main-collection-nav");

    tabsParent.each(function(index, elem) {
      const tabsSlider = elem.querySelector(".collection-nav--swiper");

      const activeSlideIndex = Array.from(tabsSlider.querySelectorAll('.swiper-slide')).findIndex(slide => 
        slide.classList.contains("active")
      );
      const initialSlideIndex = activeSlideIndex !== -1 ? activeSlideIndex : 0;

      let slider = new Swiper(tabsSlider, {
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 8,
        initialSlide: initialSlideIndex,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
        breakpoints: {
          1024: {
            spaceBetween: 16,
          }
        }
      });
    });
  }

  initMainCollectionNav();

  document.addEventListener("shopify:section:load", function () {
    initMainCollectionNav();
  });
})();
